
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Home, Map, Layers } from 'lucide-react';

const Visualizador = () => {
  const navigate = useNavigate();
  const [selectedLayer, setSelectedLayer] = useState('jerarquizacion');

  const layers = [
  { id: 'jerarquizacion', name: 'Jerarquización', url: '//umap.openstreetmap.fr/en/map/jerarquizacion-general_1359169?scaleControl=false&miniMap=false&scrollWheelZoom=false&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true' },
  { id: 'erosion', name: 'J. Erosión', url: '//umap.openstreetmap.fr/en/map/jerarquizacion-erosion_1359227?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true' },
  { id: 'escurrimiento', name: 'J. Escurrimiento', url: '//umap.openstreetmap.fr/en/map/jerarquizacion-general_1359169?scaleControl=false&miniMap=false&scrollWheelZoom=false&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true' },
  { id: 'deforestacion', name: 'J. Deforestación', url: '//umap.openstreetmap.fr/en/map/jerarquizacion-deforestacion_1358721?scaleControl=false&miniMap=false&scrollWheelZoom=false&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true' },
  { id: 'uso_agropecuario', name: 'J. Uso Agropecuario', url: '//umap.openstreetmap.fr/en/map/jerarquizacion-agropecuario_1361720?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true' },
  { id: 'incendios', name: 'J. Incendios', url: '//umap.openstreetmap.fr/en/map/jerarquizacion-erosion_1359231?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true' },
  { id: 'conservacion', name: 'J. Imp. convervación', url: '//umap.openstreetmap.fr/en/map/jerarquizacion-conservacion_1359237?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true' },
  { id: 'densidad', name: 'J. Densidad de población', url: '//umap.openstreetmap.fr/en/map/jerarquizacion-densidad-de-poblacion_1359240?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true' },
    { id: 'rezago', name: 'J. Rezago Social', url: '//umap.openstreetmap.fr/en/map/jerarquizacion-rezago-social_1359242?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true' },
  ];


  const currentLayer = layers.find((l) => l.id === selectedLayer) || layers[0];

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Header */}
      <motion.header
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="bg-gray-800 border-b border-gray-700 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/')}
                className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
                <Home className="w-6 h-6 text-gray-400 hover:text-white" />
              </button>
              <Map className="text-blue-400 w-8 h-8" />
              <div>
                <h1 className="text-2xl font-bold">Visualizador de Mapas</h1>
                <p className="text-gray-400">Sistema de Jerarquización de Cuencas - GeoNode</p>
              </div>
            </div>
          </div>
        </div>
      </motion.header>

      {/* Main Content */}
      <div className="container mx-auto px-6 py-8">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="bg-gray-800 rounded-xl overflow-hidden shadow-2xl">
          <div className="p-4 bg-gradient-to-r from-blue-600 to-green-600">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-xl font-bold text-white">Mapa Interactivo de Microcuencas</h2>
                <p className="text-blue-100 text-sm">Visualización geoespacial de las cuencas hidrográficas de Chiapas</p>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2">
                <Layers className="w-5 h-5 text-white" />
                <select
                  value={selectedLayer}
                  onChange={(e) => setSelectedLayer(e.target.value)}
                  className="bg-white text-gray-900 rounded-md px-3 py-1.5 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-300 cursor-pointer">
                  {layers.map((layer) =>
                  <option key={layer.id} value={layer.id}>{layer.name}</option>
                  )}
                </select>
              </div>
            </div>
          </div>
          
          <div className="relative w-full" style={{ height: 'calc(100vh - 250px)', minHeight: '600px' }}>
            <iframe
              style={{ width: '100%', height: '100%', border: 0 }}
              allowFullScreen
              allow="geolocation"
              src={currentLayer.url}
              title="Mapa de Jerarquización - OpenStreetMap" />

          </div>
          <div className="bg-gray-750 pt-[2px] pl-[24px] pr-[24px] pb-[10px]">
            {/* Simbología */}
            <div className="mb-[6px]">
              <h3 className="text-lg font-bold text-white text-center mb-[6px]">Simbología de Priorización</h3>
              <div className="grid grid-cols-1 md:grid-cols-5 gap-3 max-w-5xl mx-auto">
                <div className="flex items-center space-x-3 bg-gray-700 p-3 rounded-lg">
                  <div className="w-6 h-6 rounded bg-red-600 flex-shrink-0"></div>
                  <div>
                    <p className="font-semibold text-white text-sm">Muy Alta</p>
                    <p className="text-gray-300 text-xs">Intervención inmediata</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3 bg-gray-700 p-3 rounded-lg">
                  <div className="w-6 h-6 rounded bg-orange-500 flex-shrink-0"></div>
                  <div>
                    <p className="font-semibold text-white text-sm">Alta</p>
                    <p className="text-gray-300 text-xs">Intervención prioritaria</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3 bg-gray-700 p-3 rounded-lg">
                  <div className="w-6 h-6 rounded bg-[#fef9c3] flex-shrink-0"></div>
                  <div>
                    <p className="font-semibold text-white text-sm">Media</p>
                    <p className="text-gray-300 text-xs">Intervención programada</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3 bg-gray-700 p-3 rounded-lg">
                  <div className="w-6 h-6 rounded bg-[#a6d96a] flex-shrink-0"></div>
                  <div>
                    <p className="font-semibold text-white text-sm">Baja</p>
                    <p className="text-gray-300 text-xs">Monitoreo regular</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3 bg-gray-700 p-3 rounded-lg">
                  <div className="w-6 h-6 rounded bg-[#1a9641] flex-shrink-0"></div>
                  <div>
                    <p className="font-semibold text-white text-sm">Muy Baja</p>
                    <p className="text-gray-300 text-xs">Conservación</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Enlace pantalla completa */}
            <div className="text-center pt-2 border-t border-gray-600">
              <a
                href={currentLayer.url.replace('scrollWheelZoom=false', 'scrollWheelZoom=true')}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 underline text-sm">

                Ver en pantalla completa
              </a>
            </div>
          </div>
        </motion.div>

        {/* Información adicional */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mt-6 bg-gray-800 rounded-xl p-6">
          <h3 className="text-lg font-bold text-white mb-3">Acerca del Visualizador</h3>
          <p className="text-gray-300 text-sm mb-2">
            Este mapa interactivo permite explorar geográficamente las microcuencas hidrográficas del estado de Chiapas. 
          </p>
          <p className="text-gray-400 text-xs">
            Utilice las herramientas del mapa para acercar, alejar y obtener información de cada microcuenca.
          </p>
        </motion.div>
      </div>
    </div>);

};

export default Visualizador;